import styled from "@emotion/styled"
import React from "react"
import { Hugeicon } from "../../../icons/Hugeicon"
import { borderRadius, gap } from "../../../styles/vars"

type NetworkSharingValue = "yes" | "no"

type Props = {
  value: NetworkSharingValue
  onChange: (value: NetworkSharingValue) => void
}

const NetworkSharingSelector: React.FC<Props> = ({ value, onChange }) => {
  return (
    <OptionsRow>
      <Option $selected={value === "yes"} onClick={() => onChange("yes")}>
        {value === "yes" && <CheckIcon />}
        <OptionTitle>My website + CivicLift network</OptionTitle>
        <OptionDescription>Share with the community</OptionDescription>
      </Option>
      <Option $selected={value === "no"} onClick={() => onChange("no")}>
        {value === "no" && <CheckIcon />}
        <OptionTitle>My website only</OptionTitle>
        <OptionDescription>Keep it private</OptionDescription>
      </Option>
    </OptionsRow>
  )
}

const CheckIcon: React.FC = () => (
  <CheckIconWrapper>
    <Hugeicon name="tick" size={16} />
  </CheckIconWrapper>
)

const CheckIconWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  color: #42872a;
`

const OptionsRow = styled.div`
  display: flex;
  gap: ${gap};
  width: 100%;

  & > div {
    flex: 1;
  }
`

const Option = styled.div<{ $selected: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: ${borderRadius};
  padding: 16px 12px;
  min-height: 70px;
  cursor: pointer;
  transition: all 0.15s ease;

  ${props =>
    props.$selected
      ? `
    background: rgba(111, 191, 83, 0.12);
    color: #42872a;
    border: 2px solid #6fbf53;
    font-weight: 500;
  `
      : `
    background: #fff;
    color: #999;
    border: 1px solid #d8d8d8;
  `}

  &:hover {
    border-color: ${props => (props.$selected ? "#6fbf53" : "#b0b0b0")};
    ${props => !props.$selected && `color: #666;`}
  }
`

const OptionTitle = styled.div`
  font-size: 14px;
  line-height: 1.3;
`

const OptionDescription = styled.div`
  font-size: 12px;
  font-style: italic;
  margin-top: 4px;
  opacity: 0.75;
`

export default NetworkSharingSelector
